import {
    PortfolioCentralRateGroupOverview,
    PortfolioCentralRateGroupOverviewFilters,
    useRepositoryQuery,
    useRepositoryMutation,
} from '@mews-commander/data-access';
import { LocalizedText, lt, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { TableState } from '@optimus-web/core';

export const useDeleteCentralRateGroupMutation = () =>
    useRepositoryMutation('portfolioCentralRateGroups', 'delete', {
        invalidateQueries: {
            portfolioCentralRateGroups: ['getOverview'],
            portfolioRateGroups: ['getOverview'],
        },
        onSuccess: () => {
            showSuccessAlert({
                title: <LocalizedText textKey={TextKey.CentralRateGroupDeletedSuccessMessage} />,
            });
        },
    });

export const useEditCentralRateGroup = ({ linkedRateGroups }: { linkedRateGroups: number }) =>
    useRepositoryMutation('portfolioCentralRateGroups', 'update', {
        invalidateQueries: {
            portfolioCentralRateGroups: ['getOverview', 'getAll'],
            portfolioRateGroups: ['getOverview'],
            rateGroups: ['getAll'],
        },
        onSuccess: () => {
            showSuccessAlert({
                title: lt('RateGroupEditedSuccessTitle'),
                description: (
                    <LocalizedText
                        textKey={TextKey.RateGroupEditedSuccessfullyDescription}
                        substitutes={{ count: linkedRateGroups }}
                    />
                ),
            });
        },
    });

export const usePortfolioCentralRateGroupOverview = (
    tableState: TableState<PortfolioCentralRateGroupOverview, PortfolioCentralRateGroupOverviewFilters>
) =>
    useRepositoryQuery('portfolioCentralRateGroups', 'getOverview', {
        pagination: tableState.pagination,
        filters: tableState.filters,
        sort: tableState.sort,
    });
